module.exports = __webpack_public_path__ + "static/09-ab4a886de8503a7483faedc5bbba5e88.jpg";